import ActionTypes from './../common/ActionTypes';
import Strings from './../common/Strings';

function changeDay(day) {
  return {
    type: ActionTypes.DAY_CHANGED,
    day,
  };
}
function mobileBlockContinueClicked(showMobileBlock) {
  return {
    type: ActionTypes.MOBILE_BLOCK_CONTINUE_CLICKED,
    showMobileBlock,
  };
}

function initialized(isInitialized) {
  return {
    type: ActionTypes.INITIALIZED,
    isInitialized,
  };
}

function menuItemClicked(index) {
  return {
    type: ActionTypes.DASHBOARD_MENU_ITEM_CLICKED,
    index,
  };
}

function activityAddClicked(isSelectProject) {
  return {
    type: ActionTypes.ACTIVITY_ADD_CLICKED,
    isSelectProject,
  };
}

function activityAddTimeClicked(project = undefined, workLog = undefined) {
  const data = {
    project,
    workLog,
  };
  return {
    type: ActionTypes.ACTIVITY_ADD_TIME_CLICKED,
    data,
  };
}

function workLogBlockClicked(project = undefined, workLogs = undefined) {
  const data = {
    project,
    workLogs,
  };
  return {
    type: ActionTypes.WORK_LOG_BLOCK_CLICKED,
    data,
  };
}

function timerProjectClicked(projectId) {
  return {
    type: ActionTypes.TIMER_PROJECT_CLICKED,
    projectId,
  };
}

function projectClicked(project) {
  return {
    type: ActionTypes.PROJECT_CLICKED,
    project,
  };
}

function addProjectClicked(isAddProject) {
  return {
    type: ActionTypes.ADD_PROJECT_CLICKED,
    isAddProject,
  };
}

function editProjectClicked(project) {
  return {
    type: ActionTypes.EDIT_PROJECT_CLICKED,
    project,
  };
}

function historyDetailsClicked(date) {
  return {
    type: ActionTypes.HISTORY_DETAILS_CLICKED,
    date,
  };
}

function showError(title, body) {
  return showDialog({
    image: '/emoji/weary.svg',
    title,
    body,
    buttonStyle: 'common-modal-positive-button',
    buttonText: Strings.COMMON.ok,
  });
}

function showDialog(dialog) {
  return {
    type: ActionTypes.SHOW_DIALOG,
    dialog,
  };
}

function closeDialog() {
  return {
    type: ActionTypes.SHOW_DIALOG,
    undefined,
  };
}

function toggleTodayListMode(listModeOn) {
  return {
    type: ActionTypes.TOGGLE_TODAY_LIST_MODE,
    listModeOn,
  };
}

function toggleHistoryListMode(listModeOn) {
  return {
    type: ActionTypes.TOGGLE_HISTORY_LIST_MODE,
    listModeOn,
  };
}

export const uiActions = {
  toggleHistoryListMode,
  toggleTodayListMode,
  changeDay,
  mobileBlockContinueClicked,
  initialized,
  menuItemClicked,
  activityAddClicked,
  activityAddTimeClicked,
  workLogBlockClicked,
  timerProjectClicked,
  projectClicked,
  addProjectClicked,
  editProjectClicked,
  historyDetailsClicked,
  showError,
  showDialog,
  closeDialog,
};



// WEBPACK FOOTER //
// ./src/actions/ui.js